import { SidebarWrapper } from '../_base/SidebarWrapper';
import { SidebarSearch } from './SidebarSearch';

import { SidebarNavigationDesktop } from '../_base/sidebar_navigation/desktop/SidebarNavigationDesktop';

import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_search } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { useTranslation } from 'react-i18next';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { TopbarInfoWrapper } from '../_base/TopbarInfoWrapper';

export function PageSearchViewsDesktop() {
  const { search_current } = use_slice_search(['search_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);
  //FIELDS
  /*
   * HTML
   */
  return (
    <>
      <div className="w-full relative flex h-screen text-center ">
        <SidebarNavigationDesktop />

        <SidebarWrapper>
          <SidebarSearch />
        </SidebarWrapper>

        <div
          className={` h-full flex flex-col justify-start items-start`}
          style={{ width: `calc(100vw - ${CONSTANTS__client.DESKTOP_NAV_BAR_WIDTH + CONSTANTS__client.SIDEBAR_LEFT_WIDTH}px)` }}
        >
          <TopbarInfoWrapper>
            <span className="w-full text-left px-4">{t(i18n_page_search.grid.title)}</span>
          </TopbarInfoWrapper>

          <GRID2D__master entity_type={ENUM__workspace_entity.ENTITY_SEARCH} entity_id={search_current._id} />
        </div>
      </div>
    </>
  );
}
